/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFlag2 = createReactComponent("flag-2", "IconFlag2", [
  ["path", { d: "M5 14h14v-9h-14v16", key: "svg-0" }]
]);

export { IconFlag2 as default };
//# sourceMappingURL=IconFlag2.js.map
